import type { FC } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

export const ALL = "all";

type Props = {
  label: string;
  value: string;
  options: ReadonlyArray<{ id: string; label: string }>;
  onChange: (value: string) => void;
};

export const FilterSelect: FC<Props> = ({
  label,
  value,
  options,
  onChange
}) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger
      size="sm"
      aria-label={label}
      className={cn("h-7 max-w-44 text-sm", value === ALL && "text-fg-3")}
    >
      <SelectValue placeholder={label} />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL}>{label}: all</SelectItem>
      {options.map((o) => (
        <SelectItem key={o.id} value={o.id}>
          {o.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
